import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const { user, login, error, setError } = useAuth();
  const [email, setEmail] = useState("parent@example.com");
  const [password, setPassword] = useState("parent123");
  const [submitting, setSubmitting] = useState(false);

  // Clear any stale error carried over from a previous /register attempt
  useEffect(() => { setError(""); }, [setError]);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await login(email, password);
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Left visual */}
      <div className="hidden md:flex md:w-1/2 relative items-center justify-center p-12 overflow-hidden bg-[#E8E6DF]">
        <img
          src="/img/yoda-hero.png"
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-90"
        />
        <div className="relative z-10 max-w-md text-[#2C342A]">
          <div className="inline-flex items-center gap-2 mb-6 bg-white/85 backdrop-blur px-3 py-1.5 rounded-full border border-[#E4E2DC]">
            <img src="/img/yoda-mascot.png" alt="" className="h-5 w-5 rounded-full" />
            <span className="text-xs uppercase tracking-[0.22em] text-[#707A6E]">Yoda Watch</span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight">
            Do or do not — no doomscrolling, there is.
          </h1>
          <p className="mt-5 text-[#2C342A]/85 text-base">
            Daily hours, available windows, holidays. Cash-outs your kids can earn. Wise, this app is.
          </p>
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-6 md:p-12 bg-[#F5F4F0]">
        <div className="w-full max-w-md card-soft p-8 md:p-10 fade-in-up">
          <h2 className="font-heading text-3xl font-semibold text-[#2C342A]">Welcome back</h2>
          <p className="text-[#707A6E] mt-1 mb-8">Sign in to manage your family.</p>

          <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.18em] text-[#707A6E]">Email</label>
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full rounded-xl border border-[#E4E2DC] bg-white px-4 py-3 text-[#2C342A] outline-none focus:border-[#5C7A4F]"
                required
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.18em] text-[#707A6E]">Password</label>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full rounded-xl border border-[#E4E2DC] bg-white px-4 py-3 text-[#2C342A] outline-none focus:border-[#5C7A4F]"
                required
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-[#C06E52] bg-[#C06E52]/10 rounded-xl px-3 py-2">
                {error}
              </div>
            )}
            <button
              data-testid="login-submit-btn"
              disabled={submitting}
              type="submit"
              className="w-full rounded-xl bg-[#5C7A4F] text-white px-6 py-3 font-medium hover:bg-[#4B6640] transition-colors disabled:opacity-60"
            >
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <p className="mt-4 text-sm text-center">
            <Link to="/forgot-password" className="text-[#707A6E] hover:text-[#2C342A] hover:underline" data-testid="goto-forgot">
              Forgot your password?
            </Link>
          </p>

          <p className="mt-4 text-sm text-[#707A6E] text-center">
            New here?{" "}
            <Link to="/register" className="text-[#5C7A4F] hover:underline font-medium" data-testid="goto-register">
              Create a parent account
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
